import { FuseNavigationItem } from '@fuse/components/navigation';
import { FeatureKey } from 'app/core/entitlements/entitlements.types';

/**
 * The application menu.
 *
 * Lives here rather than in `mock-api/` because the menu is real product
 * structure, not demo data — serving it through the Fuse mock HTTP layer meant
 * the sidebar could not react to anything the app knew.
 */

/** A menu item, plus what it costs to reach it. */
export interface AlturaNavigationItem extends FuseNavigationItem {
    /** Plan feature that unlocks this item. Absent means every plan has it. */
    requires?: FeatureKey;
    /** Only shown to tenants flying under this rule. Absent means both. */
    onlyForRule?: 'part91' | 'part135';
}

export const NAVIGATION: AlturaNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'feather:home',
        link: '/dashboard',
    },
    {
        id: 'calendar',
        title: 'Calendar',
        type: 'basic',
        icon: 'feather:calendar',
        link: '/calendar',
    },
    // Trips is parked, not deleted. The dashboard and the calendar both open
    // a trip, and a third door to the same room earns its place in a menu
    // this long only if somebody misses it.
    // {
    //     id: 'trips',
    //     title: 'Trips',
    //     type: 'basic',
    //     icon: 'mat_outline:flight_takeoff',
    //     link: '/trips',
    // },
    {
        id: 'aircraft',
        title: 'Aircraft',
        type: 'basic',
        icon: 'mat_outline:local_airport',
        link: '/aircraft',
    },
    {
        id: 'people',
        title: 'People',
        type: 'basic',
        icon: 'feather:users',
        link: '/people',
    },
    {
        id: 'duties',
        title: 'Duties',
        type: 'basic',
        icon: 'mat_symbols_search_activity',
        link: '/duties',
        requires: 'flightHours',
    },
    {
        id: 'passenger-requests',
        title: 'Requests',
        type: 'basic',
        icon: 'mat_outline:assignment',
        link: '/trips/requests',
        requires: 'passengerRequests',
    },
    {
        id: 'quotes',
        title: 'Quotes',
        type: 'basic',
        icon: 'mat_outline:request_quote',
        link: '/quotes',
        requires: 'quotes',
        onlyForRule: 'part135',
    },
    {
        id: 'reports',
        title: 'Reports',
        type: 'basic',
        icon: 'mat_outline:analytics',
        link: '/reports',
        requires: 'csvExport',
    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'basic',
        icon: 'feather:settings',
        link: '/settings',
    },
    {
        id: 'help',
        title: 'Help',
        type: 'basic',
        icon: 'feather:help-circle',
        link: '/help',
    },
];

/** The reduced set shown on narrow screens. */
export const NAVIGATION_MOBILE: AlturaNavigationItem[] = NAVIGATION.filter((i) =>
    ['dashboard', 'aircraft', 'people', 'passenger-requests', 'settings'].includes(
        i.id as string
    )
);
